import BasicButton from "../../../components/Buttons/BasicButton";
import XsCont from "../../../components/containers/Xs";
import HeaderWithoutSignIn from "../../../components/headers/HeaderWithoutSignIn";
import { Box, Container, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const UserInfoUpdateCompletePage: React.FC = () => {
  const navigate = useNavigate();
  const handleClickButton = () => {
    navigate("/menu");
  };
  return (
    <>
      <HeaderWithoutSignIn />
      <Container maxWidth={"xl"}>
        <Box textAlign="center" mt={15}>
          <Typography variant="h5" gutterBottom>
            情報変更完了
          </Typography>
        </Box>
        <Box mt={10} textAlign="center">
          <Typography variant="body1" gutterBottom>
            登録情報を変更しました。
          </Typography>
        </Box>
      </Container>
      <XsCont>
        <BasicButton onClick={handleClickButton} mt={10}>
          メニュー
        </BasicButton>
      </XsCont>
    </>
  );
};

export default UserInfoUpdateCompletePage;
